export default __webpack_public_path__ + "static/media/PASSWORD_ICONA.e3479791.svg";